import Swiper from 'swiper/bundle';

let expertiseSwiper = null;

function initSwiper () {
    if (!document.querySelector('.expertise__lists')) return;

    expertiseSwiper = new Swiper('.expertise__lists', {
        pagination: {
            el: '.expertise__lists .swiper-pagination',
            clickable: true,
        },
    });

    expertiseSwiper.on('init', checkScreenWidth);
    expertiseSwiper.on('slideChange', checkScreenWidth);
}

function destroySwiper () {
    if (expertiseSwiper) {
        expertiseSwiper.destroy(true, true);
        expertiseSwiper = null;
    }
}

function checkScreenWidth () {
    if (window.innerWidth < 1024) {
        if (!expertiseSwiper) {
            initSwiper();
        }
    } else {
        destroySwiper();
    }
}

function setupEventListeners () {
    document.addEventListener('DOMContentLoaded', checkScreenWidth);
    window.addEventListener('resize', checkScreenWidth);
}

setupEventListeners();
